/* Wallet set notice (#1203, 28.10.2026) — product-page half of the wallet shelf grid LP (#1180).
 * Runs ONLY when the URL carries ?_afl_lp=<source> (the marker every shelf link wears). Then:
 *   1. cart attribute _afl_lp = gate (the live wallet-clear gate needs the attribute AND a line property);
 *   2. every /cart/add from this page gets properties {_afl_lp: gate, Set, _afl_src} on this product's variants —
 *      fetch is wrapped the way afroyla-preorder-cart.js does it, so the buybox, set picker and upsell paths all count;
 *   3. a plate under Add to cart says "claim {k} more FREE on the shelf"; the box at the top of the cart drawer is the
 *      shared claim moment (#1385, afroyla-wallet-claim.js): "CLAIM 2 WALLETS FREE" + one button back to the shelf;
 *   4. the page's own wallet links keep the marker so the flow survives a colour-sibling hop.
 * Maths mirror afroyla-wallet-shelf.js (priciest of each 3 paid, caps 49.95/89.95/119.95); the drawer is the truth. */
(function () {
  var host = document.querySelector('[data-afl-wsn]');
  if (!host || !window.fetch || window.__aflWsnInit) return;
  var src = host.getAttribute('data-source') || 'wallet-shelf';
  var params;
  try { params = new URLSearchParams(location.search); } catch (e) { return; }
  if (params.get('_afl_lp') !== src) return; // direct visit: the page looks as before
  window.__aflWsnInit = true;
  /* #1205: belt and braces for the section's inline flag — the CSS keyed on this class hides the site-wide code
     strip + code chips (Pick 3 is the only offer on a page opened from the shelf). Display only; the coupon A/B untouched. */
  try { document.documentElement.classList.add('afl-wsn-shelf'); } catch (e) {}

  var key = host.getAttribute('data-key') || 'wallet-clear';
  var setName = host.getAttribute('data-set-name') || '';
  var lpUrl = host.getAttribute('data-lp-url') || '/pages/wallet-shelf';
  var types = (host.getAttribute('data-types') || 'Wallet,Mini Wallet').split(',').map(function (t) { return t.replace(/^\s+|\s+$/g, ''); });
  var mine = {};
  (host.getAttribute('data-variant-ids') || '').split(',').forEach(function (id) { if (id) mine[id] = true; });
  var tiers = { 3: 49.95, 6: 89.95, 9: 119.95 };
  try { tiers = JSON.parse(host.getAttribute('data-tiers') || '{}') || tiers; } catch (e) {}
  var copy = {};
  try { copy = JSON.parse(host.querySelector('[data-afl-wsn-copy]').textContent) || {}; } catch (e) {}
  var st = { units: [], plain: 0 };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var money = function (n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); };
  var nativeFetch = window.fetch;
  var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

  /* ---- 1 · cart attribute, once ---- */
  var attrReady = null;
  function ensureAttr() {
    if (!attrReady) {
      attrReady = nativeFetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: jsonHeaders, body: JSON.stringify({ attributes: { _afl_lp: key, _afl_src: src } }) })
        .then(function (r) { if (!r.ok) throw new Error('cart/update ' + r.status); })
        .catch(function () { attrReady = null; });
    }
    return attrReady;
  }

  /* ---- 2 · gate properties on every add of this product ---- */
  function props(obj) {
    obj.properties = obj.properties || {};
    if (obj.properties._afl_lp) return;
    obj.properties._afl_lp = key; if (setName) obj.properties.Set = setName; obj.properties._afl_src = src;
  }
  function decorate(obj) {
    if (obj && obj.id && !obj.items && mine[String(obj.id)]) props(obj);
    if (obj && Array.isArray(obj.items)) obj.items.forEach(decorate);
    return obj;
  }
  function decorateFormData(fd) {
    if (!mine[String(fd.get('id'))] || fd.get('properties[_afl_lp]')) return;
    fd.append('properties[_afl_lp]', key); if (setName) fd.append('properties[Set]', setName); fd.append('properties[_afl_src]', src);
  }
  window.fetch = function (input, init) {
    var self = this, args = arguments;
    try {
      var url = typeof input === 'string' ? input : input && input.url;
      if (url && String(url).indexOf('/cart/add') !== -1 && init && init.body) {
        if (init.body instanceof FormData) decorateFormData(init.body);
        else if (typeof init.body === 'string') { try { init.body = JSON.stringify(decorate(JSON.parse(init.body))); } catch (e) {} }
        var ready = ensureAttr();
        if (ready) return ready.then(function () { return nativeFetch.apply(self, args); });
      }
    } catch (e) {}
    return nativeFetch.apply(self, args);
  };

  /* ---- 3 · keep the marker on the page's own product links (not the drawer) ---- */
  function keepMarker() {
    Array.prototype.forEach.call(document.querySelectorAll('.afroyla-pdp a[href*="/products/"]:not([data-afl-wsn-done])'), function (a) {
      a.setAttribute('data-afl-wsn-done', '1');
      try {
        var u = new URL(a.getAttribute('href'), location.origin);
        if (u.origin !== location.origin || u.searchParams.has('_afl_lp')) return;
        u.searchParams.set('_afl_lp', src); a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });
  }

  /* ---- 4 · cart maths (mirror of the grid: greedy sets of 3, priciest paid, tier caps) ---- */
  function quote() {
    var u = st.units, n = u.length, pay = 0, free = 0, i = 0;
    while (n - i >= 3) {
      var t = n - i >= 9 ? 9 : n - i >= 6 ? 6 : 3, paidN = t / 3, sum = 0;
      for (var k = 0; k < paidN; k++) sum += u[i + k];
      pay += Math.min(sum, tiers[t] || sum); free += t - paidN; i += t;
    }
    for (; i < n; i++) pay += u[i];
    return { n: n, pay: pay, free: free };
  }
  function readCart() {
    return nativeFetch('/cart.js?wsn=' + Date.now(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var units = [], plain = 0;
        (cart.items || []).forEach(function (it) {
          if (types.indexOf(it.product_type) === -1) return;
          if (it.properties && it.properties._afl_lp === key) { for (var i = 0; i < it.quantity; i++) units.push(it.price / 100); } else plain += it.quantity;
        });
        st.units = units.sort(function (a, b) { return b - a; }); st.plain = plain;
      });
  }
  function words() {
    var q = quote(), n = q.n, target = n === 0 ? 3 : Math.ceil(n / 3) * 3, left = target - n, full = n > 0 && left === 0;
    var fill = function (s) { return String(s || '').replace(/\{n\}/g, n).replace(/\{target\}/g, target).replace(/\{k\}/g, left).replace(/\{free\}/g, q.free).replace(/\{price\}/g, money(q.pay)); };
    var plainLine = st.plain ? String(copy.plain || '').replace(/\{n\}/g, st.plain).replace('wallet in', st.plain > 1 ? 'wallets in' : 'wallet in').replace('was added', st.plain > 1 ? 'were added' : 'was added').replace('stays', st.plain > 1 ? 'stay' : 'stays') : '';
    return { q: q, n: n, full: full, dots: n % 3 || (n ? 3 : 0), state: n === 0 ? copy.zero : fill(full ? copy.full : copy.partial), plainLine: plainLine };
  }

  /* ---- 5 · paint: plate under Add to cart; the drawer box is the shared claim moment (#1385, afroyla-wallet-claim.js):
   *      "CLAIM 2 WALLETS FREE" + "Pick my 2 free wallets" → shelf#pick, "SET COMPLETE · 2 WALLETS FREE" + Checkout ---- */
  var claim = window.AflWalletClaim ? window.AflWalletClaim({ mode: 'pdp', lpUrl: lpUrl, money: money }) : null;
  function dots(w) { return '<span class="afl-wsn__dots" aria-hidden="true">' + [0, 1, 2].map(function (i) { return '<i class="' + (i < w.dots ? 'is-on' : '') + '"></i>'; }).join('') + '</span>'; }
  /* the plate's one link: plain "← Back" before the first add, the claim button once a wallet is in — the same marigold
     primary in all three states (#1394, Lam 16:48 31/10): the plate has no Checkout (the drawer carries it), so the way
     back to the shelf ("Add 3 more, get 2 more FREE" once the set is full) is its one obvious button, not a text link */
  function back(w) {
    if (w.n && claim) return claim.pickBtn(claim.words(w.q), 'afl-claim__btn');
    return '<a class="afl-wsn__back" href="' + esc(lpUrl) + '" data-hc-el="teaser-cta">' + esc(copy.back) + '</a>';
  }
  function paint() {
    var w = words(), plain = w.plainLine ? '<p class="afl-wsn__plain">' + esc(w.plainLine) + '</p>' : '';
    var form = document.querySelector('form[data-product-form]');
    if (form) {
      var plate = document.getElementById('afl-wsn-plate');
      if (!plate) {
        plate = document.createElement('div'); plate.id = 'afl-wsn-plate'; plate.className = 'afl-wsn__plate'; plate.setAttribute('role', 'status'); plate.setAttribute('data-hc-section', 'buybox');
        var note = form.querySelector('[data-atc-note]');
        if (note) note.insertAdjacentElement('afterend', plate); else form.insertAdjacentElement('afterend', plate);
      }
      plate.innerHTML = '<p class="afl-wsn__eyebrow">' + esc(copy.eyebrow) + '</p><p class="afl-wsn__offer">' + esc(copy.offer) + '</p><p class="afl-wsn__state">' + dots(w) + esc(w.state) + '</p>' + plain + back(w);
      plate.classList.toggle('is-full', w.full);
    }
    if (claim) claim.drawer(w.q, plain);
  }

  /* ---- wiring ---- */
  var timer = null;
  function refresh() { readCart().then(paint).catch(function () {}); }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 400); setTimeout(refresh, 1600); }
  document.addEventListener('theme:cart:refresh', schedule);
  document.addEventListener('shopify:cart:lines-update', function (e) { if (e && e.promise && e.promise.then) e.promise.then(schedule, schedule); else schedule(); });
  if (window.MutationObserver) new MutationObserver(keepMarker).observe(document.body, { childList: true, subtree: true });

  host.hidden = false;
  keepMarker();
  ensureAttr();
  paint();
  refresh();
})();
